function valueExistsInArray(array, value) {
  for (const item of array) {
    if (item == value) {
      return true;
    }
  }
  return false;
}
function ApiCellRenderer(params) {
  try {
    const celldata = params.colDef?.options;
    const cellvalue = params.value ? params.value : "";

    if (celldata && cellvalue) {
      const isPodField = ["pod_department", "pod", "pod/department"].includes(
        params.colDef?.field
      );

      // MULTI VALUE CASE
      if (Array.isArray(cellvalue)) {
        const matchedItems = celldata.filter((item) =>
          valueExistsInArray(cellvalue, item.id)
        );

        return (
          <span>
            {matchedItems.map((item, index) => (
              <span key={item.id}>
                {isPodField ? (
                  <a
                    href={`${process.env.REACT_APP_INTRANET_URL}viewGroups/${item.email}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.value}
                  </a>
                ) : (
                  item.value
                )}
                {index !== matchedItems.length - 1 && ", "}
              </span>
            ))}
          </span>
        );
      }

      //  SINGLE VALUE CASE
      const found = celldata.find((item) => item.id === cellvalue);
      if (!found) return null;

      if (isPodField) {
        return (
          <a
            href={`${process.env.REACT_APP_INTRANET_URL}viewGroups/${found.email}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {found.value}
          </a>
        );
      }

      return found.value;
    }

    return params.value ? params.value : "";
  } catch (error) {
    console.log(error.message);
  }
}

export default ApiCellRenderer;
